// extracted by mini-css-extract-plugin
module.exports = {"form-label-wrapper":"_1IG7hgUI","form-label":"_3wdf8_Ix","has-error":"MgnxJLRs","is-disabled":"vHcahLT7","is-uppercase":"n62Po7rB"};